module.exports = __webpack_public_path__ + "media/images/sp/articles/report_02-55c85723c6423fe849e962b3ed877875.webp";